import React from "react";
import { useStore } from "@/store/StoreContext";
import { imgSrc } from "@/lib/api";

export default function Anniversary() {
  const { content } = useStore();
  return (
    <section id="anniversary" data-testid="anniversary" className="relative overflow-hidden bg-[#F6EEDC] py-14 lg:py-20">
      <div className="gold-rule absolute left-0 top-0 w-full" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.3fr_1fr] lg:gap-14">
        <figure className="reveal overflow-hidden rounded-md border border-[#E0D3B4] shadow-[0_30px_70px_-30px_rgba(143,110,29,0.35)]">
          <img
            src={imgSrc(content?.anniversary_image_left || "/assets/topsellers/siddha-mala.jpg")}
            alt="Rudralife 25th anniversary"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
        </figure>
        <div className="reveal text-center">
          <p className="mb-4 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#8F6E1D]">Since 2001 · Silver Jubilee</p>
          <h2 data-testid="anniversary-headline" className="font-display text-3xl font-semibold leading-tight tracking-tight text-[#2B1E12] sm:text-4xl lg:text-[2.7rem]">
            Celebrating 25 Years of <span className="text-gold-gradient italic">Faith, Trust</span> & Spiritual Connection
          </h2>
          <div className="gold-rule mx-auto my-8 w-32" />
          <p className="font-display mx-auto max-w-xl text-lg italic leading-loose text-[#6B5B45]">
            {content?.anniversary_text}
          </p>
          <a
            data-testid="anniversary-cta"
            href="#collection"
            className="mt-9 inline-block border border-[#8F6E1D]/50 px-8 py-3.5 text-[11px] font-bold uppercase tracking-[0.22em] text-[#8F6E1D] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-[#1C130B]"
          >
            Discover the Collection
          </a>
        </div>
        <figure className="reveal overflow-hidden rounded-md border border-[#E0D3B4] shadow-[0_30px_70px_-30px_rgba(143,110,29,0.35)]">
          <img
            src={imgSrc(content?.anniversary_image_right || "/assets/topsellers/indra-mala.jpg")}
            alt="Rudralife 25th anniversary celebration"
            loading="lazy"
            className="aspect-[4/5] w-full object-cover"
          />
        </figure>
      </div>
      <div className="gold-rule absolute bottom-0 left-0 w-full" />
    </section>
  );
}
